import { useEffect, useState } from "react";
import { getShopsRanking } from "../api";
import { useAuth } from "../auth/AuthProvider";

function TopShopsWeeklyMiniList() {
    const { withAuth } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                setLoading(true);
                const data = await withAuth((token) => getShopsRanking(token, {
                    period: "1w",
                    limit: 5
                }));

                if (!cancelled) {
                    setItems((data?.items || []).slice(0, 5));
                }
            } catch {
                if (!cancelled) {
                    setItems([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        load();

        return () => {
            cancelled = true;
        };
    }, [withAuth]);

    if (loading) {
        return <div className="text-secondary small">Chargement...</div>;
    }

    if (items.length === 0) {
        return <div className="text-secondary small">Aucune donnée cette semaine.</div>;
    }

    return (
        <div>
            <div className="text-secondary small mb-1 border-bottom pb-1 mb-1">Ateliers les plus actifs sur 7 jours</div>
            <div className="d-flex justify-content-between align-items-center small text-secondary">
                <span>Atelier</span>
                <span>Contrôles</span>
            </div>
            <ul className="list-unstyled mb-0 small">
                {items.map((item, index) => (
                    <li key={`${item.shop_name || ""}-${index}`} className="d-flex justify-content-between align-items-center py-1">
                        <span className="text-truncate pe-2">
                            {index + 1}. {item.shop_name || "-"}
                        </span>
                        <span className="text-secondary">{item.controls_count}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default TopShopsWeeklyMiniList;